import React from 'react';

function signed(value, digits = 2, suffix = '') {
  const number = Number(value);
  if (!Number.isFinite(number)) return '—';
  return `${number > 0 ? '+' : ''}${number.toFixed(digits)}${suffix}`;
}

function unsigned(value, digits = 1, suffix = '') {
  const number = Number(value);
  return Number.isFinite(number) ? `${number.toFixed(digits)}${suffix}` : '—';
}

export default function BenchmarkTrackingPanel({ analysis }) {
  if (!analysis) return null;
  if (!analysis.available) return <p className="decision-muted">{analysis.reason || '跟踪误差样本不足。'}</p>;
  const windows = (analysis.windows || []).filter((window) => window.available);
  const primary = windows.find((window) => window.key === analysis.primary_window) || windows[0];
  return (
    <section className={`benchmark-tracking-panel tracking-${primary?.verdict?.key || 'mixed'}`}>
      <div className="benchmark-tracking-head">
        <div><span>超额稳定性结论</span><strong>{primary?.verdict?.label || '暂无结论'}</strong></div>
        <p>{primary?.verdict?.note}</p>
      </div>
      <div className="benchmark-tracking-kpis">
        <div><span>{primary?.label}累计超额</span><strong>{signed(primary?.cumulative_excess_bp, 1, 'bp')}</strong><small>产品 − 合成基准</small></div>
        <div><span>日跟踪误差</span><strong>{signed(primary?.daily_tracking_error_bp, 2, 'bp')}</strong><small>日度超额的样本标准差</small></div>
        <div><span>跑赢日占比</span><strong>{unsigned(primary?.excess_hit_rate_pct, 1, '%')}</strong><small>{primary?.positive_excess_days}/{primary?.sample_size}个对齐日</small></div>
        <div><span>剔除前3偏离日</span><strong>{signed(primary?.excess_without_top3_bp, 1, 'bp')}</strong><small>用于检查累计超额是否依赖极端日期</small></div>
      </div>
      <div className="benchmark-tracking-table-wrap">
        <table className="benchmark-tracking-table">
          <thead><tr><th>窗口</th><th>样本</th><th>累计超额</th><th>日跟踪误差</th><th>跑赢日</th><th>前3日集中度</th><th>剔除前3日</th><th>基准相关</th><th>结论</th></tr></thead>
          <tbody>{windows.map((window) => (
            <tr key={window.key}>
              <td>{window.label}</td><td>{window.sample_size}</td>
              <td>{signed(window.cumulative_excess_bp, 1, 'bp')}</td>
              <td>{signed(window.daily_tracking_error_bp, 2, 'bp')}</td>
              <td>{unsigned(window.excess_hit_rate_pct, 1, '%')}</td>
              <td>{unsigned(window.top3_absolute_share_pct, 1, '%')}</td>
              <td>{signed(window.excess_without_top3_bp, 1, 'bp')}</td>
              <td>{signed(window.correlation, 3)}</td>
              <td><span className={`tracking-verdict verdict-${window.verdict?.key}`}>{window.verdict?.label}</span></td>
            </tr>
          ))}</tbody>
        </table>
      </div>
      {primary?.extreme_days?.length ? (
        <details className="benchmark-extreme-details">
          <summary>查看对累计超额影响最大的5个对齐日</summary>
          <table><thead><tr><th>行情日</th><th>净值标签日</th><th>产品</th><th>合成基准</th><th>当日超额</th></tr></thead>
            <tbody>{primary.extreme_days.map((day) => (
              <tr key={`${day.market_date}-${day.nav_date}`}><td>{day.market_date}</td><td>{day.nav_date}</td><td>{signed(day.product_pct, 4, '%')}</td><td>{signed(day.benchmark_pct, 4, '%')}</td><td>{signed(day.excess_bp, 2, 'bp')}</td></tr>
            ))}</tbody>
          </table>
        </details>
      ) : null}
      <p className="benchmark-tracking-disclaimer">{analysis.disclaimer}</p>
    </section>
  );
}
